import React from 'react';
import { Link } from 'react-router-dom';
import PublicLayout, { PageHero } from '../../components/PublicLayout';
import { Button } from '../../components/ui/button';
import { Check, ArrowRight, Sparkles } from 'lucide-react';
import { useLanguage } from '../../lib/LanguageContext';

const plans = [
  {
    id: 'basic', name: 'Basic', price: 'Gratuit', sub: 'Pour démarrer simplement',
    style: 'basic',
    features: ['Visa Electron', 'Paiements SEPA gratuits', 'Retraits 3 €/opé hors zone', 'Application mobile'],
  },
  {
    id: 'premium', name: 'Premium', price: '9,99 €/mois', sub: 'L’équilibre confort + sérénité',
    style: 'premium', popular: true,
    features: ['Visa ou Mastercard Premium', 'Cashback 1%', 'Retraits illimités monde', 'Assurances voyages', 'Support prioritaire'],
  },
  {
    id: 'elite', name: 'Elite métal', price: '19,99 €/mois', sub: 'Mastercard métal noir, services exclusifs',
    style: 'elite',
    features: ['Mastercard métal noir 18g', 'Cashback 2% (jusqu’à 500 €/an)', 'Conciergerie 24/7', 'Accès lounges aéroport (LoungeKey)', 'Assurance annulation voyage', 'Garantie achat / retour'],
  },
];

export default function Cartes() {
  const { t } = useLanguage();
  return (
    <PublicLayout>
      <PageHero eyebrow={t('public.cartesEyebrow')} title={t('public.cartesTitle')} subtitle={t('public.cartesSubtitle')}>
        <Link to="/inscription"><Button size="lg" className="bg-white text-blue-900 hover:bg-slate-100">{t('public.orderCard')} <ArrowRight className="ml-2 w-4 h-4"/></Button></Link>
      </PageHero>
      <section id="comparatif" className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-6">
        {plans.map((p) => (
          <div key={p.id} id={p.id} className={`relative rounded-3xl p-6 md:p-7 border ${p.popular ? 'border-blue-700 ring-2 ring-blue-200 shadow-2xl' : 'border-slate-200'} bg-white`}>
            {p.popular && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-700 text-white text-xs font-semibold px-3 py-1 rounded-full">Populaire</div>}
            <div className={`bfi-card ${p.style}`} style={{ maxWidth: '100%' }}>
              <div className="flex items-center justify-between">
                <div className="text-xs uppercase tracking-widest opacity-80">BFI Groupe</div>
                <div className="text-xl font-bold italic">{p.id === 'elite' ? 'mastercard' : 'VISA'}</div>
              </div>
              {p.id === 'elite' && <div className="mt-1 inline-flex items-center gap-1 px-2 py-0.5 rounded bg-white/15 text-[10px] uppercase tracking-widest"><Sparkles className="w-3 h-3"/> Métal noir</div>}
              <div className="mt-10 font-mono tracking-widest text-sm">•••• •••• •••• 4321</div>
              <div className="flex justify-between mt-3 text-xs opacity-90"><span>BFI MEMBER</span><span>12/30</span></div>
            </div>
            <div className="mt-5">
              <div className="text-xl font-bold text-slate-900">{p.name}</div>
              <div className="text-sm text-slate-500">{p.sub}</div>
              <div className="text-2xl font-bold mt-3 text-blue-900">{p.price}</div>
              <ul className="mt-4 space-y-2 text-sm">
                {p.features.map((f, i) => <li key={i} className="flex items-start gap-2"><Check className="w-4 h-4 text-emerald-600 mt-0.5"/> {f}</li>)}
              </ul>
              <Link to="/inscription"><Button className={`mt-5 w-full ${p.popular ? 'bg-blue-700 hover:bg-blue-800' : 'bg-slate-900 hover:bg-slate-800'}`}>Choisir {p.name}</Button></Link>
            </div>
          </div>
        ))}
      </section>
      <section className="max-w-7xl mx-auto px-6 pb-20">
        <div className="rounded-3xl bg-gradient-to-br from-fuchsia-700 to-purple-900 p-10 md:p-14 text-white relative overflow-hidden">
          <div className="absolute -top-20 -right-20 w-72 h-72 bg-pink-400/30 rounded-full blur-3xl"></div>
          <div className="relative grid md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-3 py-1 text-xs font-medium"><Sparkles className="w-3 h-3"/> Nouveauté 2025</div>
              <h2 className="text-3xl md:text-4xl font-bold mt-4">Mastercard <span className="italic">Métal Noir</span> Elite</h2>
              <p className="text-white/80 mt-3">Carte en métal véritable de 18g, design noir mat, services de conciergerie 24/7, accès aux lounges aéroport et cashback 2% sur tous vos paiements.</p>
              <ul className="mt-5 space-y-2 text-sm text-white/90">
                <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-300 mt-0.5"/> Conciergerie personnelle 24h/24</li>
                <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-300 mt-0.5"/> Accès illimité aux lounges (LoungeKey)</li>
                <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-300 mt-0.5"/> Assurance voyage premium</li>
                <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-300 mt-0.5"/> Cashback 2% (jusqu’à 500 €/an)</li>
              </ul>
              <Link to="/inscription"><Button size="lg" className="mt-6 bg-white text-purple-900 hover:bg-slate-100">Commander Elite métal</Button></Link>
            </div>
            <div className="flex justify-center">
              <div className="bfi-card elite" style={{ maxWidth: 460, transform: 'rotate(-4deg)' }}>
                <div className="flex items-center justify-between">
                  <div className="text-xs uppercase tracking-widest opacity-80">BFI Groupe</div>
                  <div className="text-2xl font-bold italic">mastercard</div>
                </div>
                <div className="mt-1 inline-flex items-center gap-1 px-2 py-0.5 rounded bg-white/15 text-[10px] uppercase tracking-widest"><Sparkles className="w-3 h-3"/> Métal noir 18g</div>
                <div className="mt-10 font-mono tracking-[6px] text-lg">5497  ••••  ••••  8842</div>
                <div className="flex items-end justify-between mt-6">
                  <div><div className="text-[10px] opacity-60 uppercase">Titulaire</div><div className="font-semibold tracking-wide">CARTE ÉLITE</div></div>
                  <div><div className="text-[10px] opacity-60 uppercase">Exp.</div><div className="font-mono">12/30</div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
